import { render } from "./PurchaseOrderDetailModal.vue?vue&type=template&id=d6e8e2ca&ts=true"
import script from "./PurchaseOrderDetailModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__